import { COOKIE_ACCESS, COOKIE_REFRESH, COOKIE_USER } from './auth.constants'

export const setSessionCookies = ({
  accessToken,
  refreshToken,
  userToken,
  maxAgeAccessSec,
  maxAgeRefreshSec,
  contrato,
  idCertificado,
  idUsuario,
  emailUsuario,
}) => {
  const accessExpires = Date.now() + maxAgeAccessSec * 1000
  const refreshExpires = Date.now() + maxAgeRefreshSec * 1000

  localStorage.setItem(
    COOKIE_ACCESS,
    JSON.stringify({
      value: accessToken,
      expires: accessExpires,
    })
  )

  localStorage.setItem(
    COOKIE_REFRESH,
    JSON.stringify({
      value: refreshToken,
      expires: refreshExpires,
    })
  )

  localStorage.setItem(
    COOKIE_USER,
    JSON.stringify({
      value: userToken,
      expires: refreshExpires,
    })
  )

  if (contrato) setCookie('contrato', contrato, refreshExpires)
  if (idCertificado) setCookie('idCertificado', idCertificado, refreshExpires)
  if (idUsuario) setCookie('idUsuario', idUsuario, refreshExpires)
  if (emailUsuario) setCookie('emailUsuario', emailUsuario, refreshExpires)

  setCookie('hasSession', 'true', refreshExpires)
}

const setCookie = (name, value, expiresTimestamp) => {
  const expires = new Date(expiresTimestamp).toUTCString()
  document.cookie = `${name}=${value}; expires=${expires}; path=/; SameSite=Lax`
}

const getCookie = (name) => {
  const value = `; ${document.cookie}`
  const parts = value.split(`; ${name}=`)
  if (parts.length === 2) {
    return parts.pop().split(';').shift()
  }
  return null
}

const getStorageItem = (key) => {
  try {
    const item = localStorage.getItem(key)
    if (!item) return null

    const { value, expires } = JSON.parse(item)

    if (Date.now() > expires) {
      localStorage.removeItem(key)
      return null
    }

    return value
  } catch (error) {
    console.warn(`No se pudo recuperar ${key} desde localStorage`, error)
    localStorage.removeItem(key)
    return null
  }
}

export const clearSessionCookies = () => {
  const pastDate = new Date(0).toUTCString()

  // Limpiar localStorage
  localStorage.removeItem(COOKIE_ACCESS)
  localStorage.removeItem(COOKIE_REFRESH)
  localStorage.removeItem(COOKIE_USER)

  // Limpiar cookies
  document.cookie = `hasSession=; expires=${pastDate}; path=/`
  document.cookie = `contrato=; expires=${pastDate}; path=/`
  document.cookie = `idUsuario=; expires=${pastDate}; path=/`
  document.cookie = `idCertificado=; expires=${pastDate}; path=/`
  document.cookie = `emailUsuario=; expires=${pastDate}; path=/`

  console.info('🧹 Sesión eliminada')
}

export const getAccessToken = () => {
  const value = getStorageItem(COOKIE_ACCESS)
  return value
}

export const getRefreshToken = () => {
  const value = getStorageItem(COOKIE_REFRESH)
  return value
}

export const getUserToken = () => {
  const value = getStorageItem(COOKIE_USER)
  return value
}

export const getContrato = () => getCookie('contrato')
export const getIdCertificado = () => getCookie('idCertificado')
export const getIdUsuario = () => getCookie('idUsuario')
export const getEmailUsuario = () => getCookie('emailUsuario')

export const hasActiveSession = () => {
  return getCookie('hasSession') === 'true' && !!getUserToken()
}

export const decodeJwt = (jwt) => {
  if (!jwt) return null
  const parts = jwt.split('.')
  if (parts.length < 2) return null
  try {
    const json = atob(parts[1].replace(/-/g, '+').replace(/_/g, '/'))
    return JSON.parse(decodeURIComponent(escape(json)))
  } catch {
    return null
  }
}

export const msUntilJwtExp = (jwt, fallbackSec = 300) => {
  const payload = decodeJwt(jwt)
  const nowSec = Math.floor(Date.now() / 1000)
  const expSec = Number(payload?.exp || 0)
  const remainingSec = Math.max(0, expSec ? expSec - nowSec : fallbackSec)
  return remainingSec * 1000
}
